export default __webpack_public_path__ + "static/media/ITRealCase1-moblie.00d3c1f4.jpg";